module.exports = __webpack_public_path__ + "static/img/taiHeImg1.faf3241.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/taiHeImg1.jpg
// module id = vfo5
// module chunks = 2